// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
// Flags for various stuff
class _GlobalFlags {
    constructor() {
        this.InstrumentSaveMode = false;
    }
}
export const GlobalFlags = new _GlobalFlags();
